import io from "socket.io-client";

const route = import.meta.env.VITE_APP_API_URL;

/**
 * Cria uma nova instância de conexão WebSocket
 * @returns Socket instance configurada
 */
export function createWebSocketConnection() {
  const socket = io(route, {
    autoConnect: false, // Não conecta automaticamente
    query: {
      company: localStorage.getItem("@App:companyId")
    }
  });

  // Listeners básicos para debug (opcional)
  socket.on("connect", () => {
    // console.log("WebSocket conectado:", socket.id);
  });

  socket.on("connect_error", (_err: Error) => {
    // console.error("Erro de conexão WebSocket:", _err.message);
  });

  socket.on("disconnect", (_reason: string) => {
    // console.log("WebSocket desconectado:", _reason);
  });

  return socket;
}

/**
 * Interface para resposta de chamada de check-in
 */
export interface CheckInCallResponse {
  type: "success" | "error";
  content: string;
  driverCalled: unknown | null;
}
